export default {
    DOMICILIO: 1,
    COMERCIO: 2,
    TERRENO_BALDIO: 3,
    PONTO_ESTRATEGICO: 4,
    ESCOLA: 5,
    CRECHE: 6,
    ABRIGO: 7,
    INSTITUICAO_DE_LONGA_PERMANENCIA_PARA_IDOSOS: 8,
    UNIDADE_PRISIONAL: 9,
    UNIDADE_DE_MEDIDA_SOCIO_EDUCATIVA: 10,
    DELEGACIA: 11,
    ESTABELECIMENTO_RELIGIOSO: 12,
    OUTROS: 13,
}